import { h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import { createPortal } from 'preact/compat';
import CloseIcon from './closeIcon';
const DEFAULT_DURATION = 4000;
const Notification = ({ open , title , description , imageUrl , duration =DEFAULT_DURATION , momentary =true , onClose , className  })=>{
    const timerRef = useRef(null);
    useEffect(()=>{
        // clear any existing timer on unmount
        return ()=>{
            if (timerRef.current) {
                window.clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        };
    }, []);
    useEffect(()=>{
        if (!open) {
            if (timerRef.current) {
                window.clearTimeout(timerRef.current);
                timerRef.current = null;
            }
            return;
        }
        if (momentary) {
            // schedule auto-close
            timerRef.current = window.setTimeout(()=>{
                timerRef.current = null;
                onClose && onClose();
            }, duration);
        }
        return ()=>{
            if (timerRef.current) {
                window.clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [
        open,
        duration,
        momentary,
        onClose
    ]);
    const handleClose = ()=>{
        if (timerRef.current) {
            window.clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        onClose && onClose();
    };
    if (!open) return null;
    const node = h('div', {
        className: `notification ${className || ''}`.trim(),
        role: 'status',
        'aria-live': 'polite'
    }, // left media container
    imageUrl ? h('div', {
        className: 'notification__media'
    }, h('img', {
        src: imageUrl,
        alt: '',
        className: 'notification__image'
    })) : null, // right content container
    h('div', {
        className: 'notification__content'
    }, h('div', {
        className: 'notification__body'
    }, title ? h('div', {
        className: 'notification__title'
    }, title) : null, description ? h('div', {
        className: 'notification__desc'
    }, description) : null)), h('button', {
        type: 'button',
        className: 'notification__close',
        onClick: handleClose,
        'aria-label': 'Dismiss'
    }, // use stoq-close.svg inline
    h(CloseIcon, {
        className: 'notification__closeIcon',
        width: 20,
        height: 20
    })));
    if (typeof document !== 'undefined' && document.body) {
        return createPortal(node, document.body);
    }
    return node;
};
export default Notification;
